import { cva } from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold before:h-1.5 before:w-1.5 before:rounded-full before:bg-current',
  {
    variants: {
      variant: {
        active: 'bg-success-soft text-[#15803d]',
        inactive: 'bg-warning-soft text-[#9a3412]',
        cancelled: 'bg-danger-soft text-[#991b1b]',
        pending: 'bg-danger-soft text-danger',
        info: 'bg-info-soft text-info',
        accent: 'bg-accent-soft text-accent-dark',
      },
    },
    defaultVariants: {
      variant: 'active',
    },
  },
)
